import React from 'react'

import { useAppSelector } from '@/redux/hooks'
import { selectUserId } from '@/redux/me/meSlice'

import { TeamStaleWorkBanner } from './TeamStaleWorkBanner'

/**
 * Entry point mounted in AppLayout. Every user gets the team-wide grouped
 * banner (ENG-32130 removed the PM role gate and the owner-scoped variant):
 * the count spans all owners and includes guard acks, and each user's own
 * stale work appears as one of the groups in the team modal. Feature-flag
 * gating lives in useTeamStaleWork.
 *
 * Mounting waits for the user id (login resolves asynchronously) because the
 * banner's snooze deadline persists in localStorage keyed per user id, and
 * useLocalState reads its key only once at mount (ENG-32181).
 */
export const StaleWork = () => {
  const userId = useAppSelector(selectUserId)

  if (!userId) return null

  return <TeamStaleWorkBanner />
}
